import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Optional, Renderer2 } from "@angular/core";
import { CommonService } from "../services/common.service";
import { GlobalConversionService } from "../services/GlobalMethodService/GlobalConversion-Service";
import _ from 'lodash';

@Directive({ selector: "[decimalConverter]" })
  export class DecimalConverterDirective implements AfterViewInit { 
    textbox: HTMLInputElement;
    defaultValue: any;
    clonedValue: any;
    @Input() FormField: any;
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private globalConversion: GlobalConversionService,
        private commonService: CommonService
    ) { 

    }
    fixedDecimal(textvalue: any, decimalPoint: any, ActionType: string): any {
        try {
            let returnTextValue: any = textvalue;
            const convertStringValue: string = textvalue.toString();
            const splitedTextValue: Array<string> = (convertStringValue) ? convertStringValue.split('.') : null;
            if (ActionType === 'visible') {
                if (splitedTextValue.length === 1) {
                    returnTextValue = textvalue.toFixed(decimalPoint);
                } else if (splitedTextValue.length > 1 && splitedTextValue[1].length > decimalPoint) {
                    returnTextValue = textvalue.toFixed(decimalPoint);
                } else {
                    returnTextValue = textvalue;
                }
            } else if (ActionType === 'focus') {
                if (splitedTextValue.length === 1) {
                    returnTextValue = textvalue;
                } else if (splitedTextValue.length > 1 && splitedTextValue[1].length > decimalPoint) {
                    returnTextValue = textvalue.toFixed(decimalPoint);
                } else {
                    returnTextValue = textvalue;
                }
            }
            return returnTextValue;
        } catch(error: any) {
            console.error('Error occured in Decimal Formatter - ', error);
        }
    }
    setIntialValue(): any {
        try {
          return this.el.nativeElement.tagName === "INPUT" ? 
          this.el.nativeElement : this.el.nativeElement.querySelector("input");
        } catch (error) {
          console.error(error);
        }
      }
    @HostListener("focus", ["$event"]) onFocus(event) {
        this.textbox = this.setIntialValue();
        const checkIsNan = isNaN(this.defaultValue);
        if (!checkIsNan) {
            const formatValue = this.fixedDecimal(this.clonedValue, this.commonService.decimalFocusinLength, 'focus');
            this.renderer.setProperty(this.textbox, 'value' , formatValue);
        }
    }
    @HostListener("bluraction", ["$event"]) onBlurAction(event) {
        this.textbox = this.setIntialValue();
        this.defaultValue = (this.textbox.value !== 'undefined' && this.textbox.value !== 'null') ? 
        parseFloat(this.textbox.value) : 'null';
        this.clonedValue = _.cloneDeep(this.defaultValue);
        const checkIsNan = isNaN(this.defaultValue);
        if (!checkIsNan) {
            const formattedValue = this.fixedDecimal(this.defaultValue, CommonService.decimalvisibleLength, 'visible');
            this.renderer.setProperty(this.textbox, 'value' , formattedValue);
        }
      }
    @HostListener("blur", ["$event"]) onBlur(event) {
        this.textbox = this.setIntialValue();
        this.defaultValue = (this.textbox.value !== 'undefined' && this.textbox.value !== 'null') ? 
        parseFloat(this.textbox.value) : 'null';
        this.clonedValue = _.cloneDeep(this.defaultValue);
        const checkIsNan = isNaN(this.defaultValue);
        if (!checkIsNan) {
            const formattedValue = this.fixedDecimal(this.defaultValue, CommonService.decimalvisibleLength, 'visible');
            this.renderer.setProperty(this.textbox, 'value' , formattedValue);
        }
    }
    ngAfterViewInit(): void {
        this.textbox = this.setIntialValue();
        this.defaultValue = this.defaultValue ? 
        this.globalConversion.customformatter(this.defaultValue) : 'null';
    }
  }